import {PageTitle} from 'layout/master-layout'
import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import CreateFestiveGreeting from './CreateFestiveGreeting'

const CreateFestiveGreetingWrapper = () => {
 const {t} = useTranslation()
 const [hideParent, setHideParent] = useState(true)

 return (
  <div className='container relative'>
   <div className='px-[72px] pt-6 pb-10 bg-white w-full min-h-full'>
    {!hideParent && (
     <PageTitle
      breadcrumbContainerClass={
       'flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0] border-b'
      }
      breadcrumbs={[
       {
        title: t('breadCrumbs.home'),
        path: '/home-page',
        isActive: false,
       },
       {
        title: t('breadCrumbs.activityManagement'),
        path: '/activity-management',
        isActive: false,
       },
       {
        title: t('breadCrumbs.festiveGreeting'),
        path: '/activity-management/festive-greeting',
        isActive: false,
       },
       {
        title: t('breadCrumbs.createFestiveGreeting'),
        path:
         '/activity-management/festive-greeting/create-greeting',
        isActive: true,
       },
      ]}
      description='Welcome'
     >
      {t('breadCrumbs.createRecommendationPromotion')}
     </PageTitle>
    )}
    <CreateFestiveGreeting
     hidePartent={hideParent}
     setHideParent={setHideParent}
    />
   </div>
  </div>
 )
}

export default CreateFestiveGreetingWrapper
